module.exports = [
  "Investments",
  "Investment",
  "Anlage-/Investmentobjekte",
  "Bürogebäude (Invest.)",
  "Betreutes Wohnen (Invest)",
  "Laden/Verkaufsfläche (Invest.)",
  "Geschäftshaus (Invest.)",
  "Supermarkt (Invest.)",
  "Einkaufszentrum (Invest.)",
  "Gaststätte (Invest.)",
  "Hotel (Invest.)",
  "Halle/Lager (Invest.)",
  "Gewerbeanwesen (Invest.)",
  "Gewerbeeinheit (Invest.)",
  "Industrieanwesen (Invest.)",
  "Freizeitanlage (Invest.)",
  "Pflegeheim (Invest)",
  "Servicecenter (Invest.)",
  "Seniorenheim (Invest)",
  "Eigentumswohnung (Invest.)",
  "Einfamilienhaus (Invest.)",
  "Mehrfamilienhaus (Invest.)",
  "Wohnanlage (Invest.)",
  "Wohn-/Geschäftshaus (Invest.)",
  "Sonstiges (Invest.)",
  "Gewerbe/Anlage",
  "Zins und Renditeobjekt",
  "Zins und Renditehäuser",
  "Sonstige",
  "Anlageobjekt",
];



// WEBPACK FOOTER //
// ./src/data/investment.js